import { render } from "./NavNotification.vue?vue&type=template&id=c060c438"
import script from "./NavNotification.vue?vue&type=script&lang=js"
export * from "./NavNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__